module.exports = __webpack_public_path__ + "img/feathers.a27933b2.jpg";